import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import React from 'react';

type HourMarkerProps = {
  position: string;
  time: string;
};

export const HourMarker = ({ position, time }: HourMarkerProps) => (
  <Box
    sx={{
      left: position,
      position: 'absolute',
      height: '100%',
    }}
  >
    <Box
      sx={{
        width: '1px',
        height: '100%',
        backgroundColor: (theme) => theme.semantic.borderStrong,
      }}
    />

    <Box sx={{ transform: 'translateX(-50%)' }}>
      <Typography
        variant={'caption'}
        sx={{
          whiteSpace: 'pre',
        }}
      >
        {dayjs.utc(time).tz().format('h A')}
      </Typography>
    </Box>
  </Box>
);
